import {
  Spinner,
  Text,
  TextAlignment,
  TokenTextAppearance,
  TokenTextColor,
  TextTag,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import CustomText from '../components/CustomText.styled';
import {WrapContentCenter} from '../components/ContentWrapperStyled';
import {QuestionWrapper} from './index';
import useQuestionStore from '../store/navigation';
import {useResultStore} from '../store/responses';
import {
  sendSaleForceSurvey,
  useSalesForceObjectStore,
} from '../store/salesforce';
import {
  formatLead,
  formatSalesForceObject,
} from '../helpers/salesForceFormatter';
import {QUESTIONIDS} from '../types/question';
import {AnalyticEvent, sendAnalyticPayload} from '../utils/analytic';
import useMediaQuery from '../hooks/useMediaQuery';

export function QuestionFourteenResults({
  closeDialog,
}: {
  closeDialog?: () => void;
}): JSX.Element {
  const {result} = useResultStore();
  const {lead, tradeInEvaluation, questionThirteenForm} =
    useSalesForceObjectStore();
  const {setCurrentQuestion} = useQuestionStore();
  const {isMobile} = useMediaQuery();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      const salesForceObject = formatSalesForceObject(
        formatLead(questionThirteenForm, result),
        result,
        tradeInEvaluation,
      );

      console.log('Formated salesforce object', salesForceObject);
      sendSaleForceSurvey(salesForceObject).then((res) => {
        console.log('Send survey successfully', res);
      });

      sendAnalyticPayload(
        {
          process: {
            StepName: 'Survey Results',
            StepNumber: '100',
          },
          Configuration: {
            CarlineId: salesForceObject?.lead?.vehicle_interested_in || '',
          },
        },
        AnalyticEvent.VehicleFormSubmissionSuccessMessageLoad,
      );
      closeDialog?.();
      setCurrentQuestion(QUESTIONIDS.questionLanding);
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [
    closeDialog,
    setCurrentQuestion,
    lead,
    result,
    tradeInEvaluation,
    questionThirteenForm,
  ]);
  return (
    <QuestionWrapper
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <WrapContentCenter style={{padding: 32}}>
        <Text
          textAlign={TextAlignment.center}
          color={TokenTextColor.inherit}
          tag={TextTag.h3}
          appearance={TokenTextAppearance.headline400}
        >
          <CustomText
            customStyles={{color: 'white', fontSize: isMobile ? 32 : 48}}
          >
            Get amped
          </CustomText>
        </Text>
        <Text
          textAlign={TextAlignment.center}
          color={TokenTextColor.inherit}
          tag={TextTag.h3}
          appearance={TokenTextAppearance.headline400}
        >
          <CustomText
            customStyles={{
              color: 'white',
              fontSize: isMobile ? 32 : 48,
              fontWeight: 700,
            }}
          >
            It’s time to meet your match
          </CustomText>
        </Text>
        <div style={{marginTop: 40}}>
          <Spinner variant="large" />
        </div>
      </WrapContentCenter>
    </QuestionWrapper>
  );
}
